
import './index.less'
import React from 'react'

export default function NovelIfon(props) {
  return (<div className={`NovelIfon ${props.selectItem ? props.selectItem.id === props.compIfon.id ? 'active' : '' : ''}`}>

    <div className={`NovelIfonBox `}>
      {!props.ifon.image.src ? null : <div className='NovelIfonBox_left'>
        <img className='img' src={props.ifon.image.src} />
      </div>}

      <div className='NovelIfonBox_right' dangerouslySetInnerHTML={{ __html: props.ifon.html }}>

      </div>
    </div>

  </div>)
}
console.log(React)
